import styled from "styled-components";
import { ReactComponent as Swaps } from "../../../assets/images/svg/swaps.svg";
export const SwapsIcon = styled(Swaps)``;